const setOtherOccupation = (val = null) => {
  return {
    type: 'SET_OTHEROCCUPATION',
    data: val,
  }
}

export default {
  setOtherOccupation,
}
